export default class ModalBox {
    constructor() {
        this.elementsTag = '[data-open-modal]';
        this.modalBoxTag = '[data-modal-box]';
        this.backdropTag = '[data-modal-backdrop]';
        this.closingTag = '[data-modal-close]';
        this.openModalModifier = 'modalBox--show';
        this.showBackdropModifier = 'modalBox__backdrop--show';
        this.modalTitleTag = '[data-modal-title]';
        this.modalContentTag = '[data-modal-content]';
        this.init();
    }

    init() {
        this.elements = document.querySelectorAll(this.elementsTag);
        if (this.elements.length === 0) {
            return false;
        }

        const modal = document.querySelectorAll(this.modalBoxTag)[0];
        const backDrop = document.querySelector(this.backdropTag);

        this.registerCloseClick(
            this.getCloseIcon(),
            modal,
            backDrop
        );

        this.elements.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                if (modal !== null) {
                    this.setContent(
                        e.currentTarget.dataset.title,
                        e.currentTarget.dataset.text,
                    );
                    this.openModal(modal);
                    this.openModalBackdrop(backDrop);
                }
            });
        });
    }

    getCloseIcon() {
        return document.querySelector(this.closingTag);
    }

    getModalOpeners() {
        return document.querySelectorAll(this.elementsTag);
    }

    closeModal(modal) {
        modal.classList.remove(this.openModalModifier);
    }

    openModal(modal) {
        modal.classList.add(this.openModalModifier);
    }

    openModalBackdrop(backDropElement) {
        backDropElement.classList.add(this.showBackdropModifier);
    }

    hideBackdrop(backDropElement) {
        backDropElement.classList.remove(this.showBackdropModifier);
    }

    setContent(title, text) {
        if (title) {
            document.querySelector(this.modalTitleTag).innerHTML = title;
        }

        if (text) {
            document.querySelector(this.modalContentTag).innerHTML = text;
        }
    }

    registerCloseClick(icon, modal, backDrop) {
        icon.addEventListener('click', () => {
            this.closeModal(modal);
            this.hideBackdrop(backDrop);
        });
    }
}
